/*
 * View for the saving display
 */

define(["marionette", "modules/savingDisplay/template/savingDisplayTemplate.html"], function (
  Marionette,
  SavingDisplayTemplate,
) {
  var SavingDisplayView = {};

  SavingDisplayView.savingDisplayView = Marionette.ItemView.extend({
    template: SavingDisplayTemplate,
  });

  return SavingDisplayView;
});
